import i from "./get.mjs";
import { isDefined as c, getKeys as f } from "./types3.mjs";
import { JSON_KEY_DARK as _, JSON_KEY_LIGHT as a, JSON_KEY_STENN_HUB as x } from "./constants29.mjs";
import K from "./tokens.json.mjs";
import { deprecatedCommonPaletteGroup as l } from "./deprecatedTheme.mjs";
const u = K.brand, E = ({
  variant: e,
  mode: r
}) => {
  switch (e) {
    case "stennHub":
      return {
        ...u[x],
        ...l
      };
    default:
      return {
        ...u[r === "dark" ? _ : a],
        ...l
      };
  }
}, J = (e, { addPx: r, mappings: t } = {}) => {
  const o = u[e];
  return f(o).reduce((n, p) => {
    const m = o[p];
    return n[p] = c(t) ? t[m.value] : m.value, r && !n[p].includes("%") && (n[p] += "px"), n;
  }, {});
}, O = (e, r) => i(e, r.replace(/{|}/g, "")), s = (e) => `${e.x}px ${e.y}px ${e.blur}px ${e.spread}px ${e.color}`, T = (e) => Array.isArray(e) ? e.reduce((r, t, o) => (r += s(t), o < e.length - 1 && (r += ","), r), "") : s(e);
export {
  T as compileShadow,
  J as compileTokenGroup,
  O as computeFieldByPath,
  E as getColorModePalette,
  s as makeShadowStyleFromToken
};
//# sourceMappingURL=utils8.mjs.map
